import React, { useEffect } from 'react'
import Header2 from '../../layout/Header2'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { useLanguage } from '../../contexts/LanguageContext'
import ServicesBanner from '../../components/haseeb/ServicesBanner'
import BannerImg from '../../assets/images/bannners/SearchEngineOptimization.webp'
import ImageBorderStyleRight from '../../components/haseeb/ImageBorderStyleRight'
import ImageBorderStyleLeft from '../../components/haseeb/ImageBorderStyleLeft'
import Img1 from '../../assets/images/seo/Img1.webp'
import Img2 from '../../assets/images/seo/Img2.webp'
import Img3 from '../../assets/images/seo/Img3.webp'
import Img4 from '../../assets/images/seo/Summit-our-drive.webp'
import Img5 from '../../assets/images/seo/Img5.webp'
import MiddleBannerPrimary from '../../components/haseeb/MiddleBannerPrimary'
import MiddleBannerSecondary from '../../components/haseeb/MiddleBannerSecondary'
import { ChevronRight } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { Col, Row } from 'reactstrap'
import { FaDotCircle } from 'react-icons/fa'

const SearchEngineOptimization = () => {
    const { t } = useLanguage();
    
    useEffect(() => {
        window.scrollTo(0,0);
    },[])
    
    return (
    <>
      <HelmetProvider>
        <Helmet prioritizeSeoTags>
          <title>software development & digital marketing agency in Germany - IT Junction </title>
        </Helmet>
      </HelmetProvider>
    <Header2/>
    <ServicesBanner
    BannerImg={BannerImg}
    SubTitle={t('servicePages.seo.subtitle')}
    Title={t('servicePages.seo.title')}
    />
<section id='website-responsive' className="container-fluid px-0">
<div id='website-responsive'>
        <div className='container-fluid ps-lg-5 ps-4 py-lg-5 py-4'>
            <Row className=''>
                <Col lg='3' className='pb-5'>
                    <div className='pb-md-3 pb-lg-0 pb-3'>
                        <div className='d-flex align-items-center'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/healthcare-solutions' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.healthcareSolutions')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/branding/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.branding')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/graphic-designing' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.graphicDesigning')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/content-writing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.contentWriting')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/web-development/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.webDevelopment')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/app-development/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.appDevelopment')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                            <Link to='/services/search-engine-optimization/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-24 text-mulish fw-500 text-ss-primary'>
                                    {t('services.seo')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                            <Link to='/services/social-media-marketing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.socialMediaMarketing')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/video-animation/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.videoAnimation')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/ppc-marketing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.ppcMarketing')}
                            </span>
                                </Link>
                        </div>
                    </div>
                </Col>

                <Col className='ps-lg-4 d-none d-lg-block'>
                        <div className='d-block d-lg-flex align-items-start'>
                          <div className='w-75'>
                          <div className='mb-lg-4 mb-3'>
                            <h2 className='fs-ss-36 text-philos fw-800 text-ss-black'>
                            {t('servicePages.seo.comprehensiveTitle')}
                            </h2>
                        </div>
                            <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
                            {t('servicePages.seo.comprehensiveDescription')}
                            </p>
                            </div>
                            <div className='px-lg-5'>
                            <img className='' src={Img4} alt="Seo" style={{width:"400px"}} />
                        </div>
                    </div>
                </Col>
                
                <Col className='d-block d-lg-none'>
                          <div className='mb-lg-4 mb-3'>
                            <h2 className='fs-ss-36 text-philos fw-800 text-ss-black'>
                            {t('servicePages.seo.comprehensiveTitle')}
                            </h2>
                        </div>
                            <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
                            {t('servicePages.seo.comprehensiveDescription')}
                            </p>
                            <div className='px-lg-5'>
                            <img className='w-100' src={Img4} alt="Seo"/>
                    </div>
                </Col>
            </Row>
        </div>
    </div>
    </section>


    <section className="container-fluid pb-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-10">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.seo.ascendingTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.seo.ascendingDescription')} 
             </p>
        </div>
        </div>
      </div>
    </section>

    <MiddleBannerPrimary
    Title={
      <>
        <span className='text-white'>{t('servicePages.seo.lookingForTitle')}</span>
      </>
    }
    Para={t('servicePages.seo.lookingForDescription')}
    />
    
    <section className="container-fluid py-4 py-lg-5">
      <div className='row justify-content-evenly align-items-center gy-4'>
        <div className="col-11 col-md-5">
          <img className='w-100' src={Img5} alt="" />
        </div>
        <div className="col-11 col-md-5">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.seo.organicTrafficTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.seo.organicTrafficDescription')}           
             </p>
        </div>
        </div>
      </div>
    </section>

    <MiddleBannerSecondary
    Title={t('servicePages.seo.researchTitle')}
    Para={
      <>
        {t('servicePages.seo.researchDescription')}
        <div className='pt-4'>
          <Link to="/packages" className="text-decoration-none text-white fs-ss-18 fw-500 border-2 border-white border py-2 px-3"> {t('packages.title')} <ChevronRight className='fs-ss-22'/> </Link>
        </div>
      </>
    }
    />
    <div className='pt-4 pt-lg-0'/>
    <ImageBorderStyleLeft
    Img={Img1}
    Title={t('servicePages.seo.wantedTrafficTitle')}
    Para={t('servicePages.seo.wantedTrafficDescription')}
    />
    
    <ImageBorderStyleRight
    Img={Img2}
    Title={t('servicePages.seo.trackingLeadsTitle')}
    Para={t('servicePages.seo.trackingLeadsDescription')}
    />

    <ImageBorderStyleLeft
    Img={Img3}
    Title={t('servicePages.seo.authorityBuildingTitle')}
    Para={t('servicePages.seo.authorityBuildingDescription')}
    />

<section className="container-fluid pb-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-10">
        <div className='mb-4'>
        <div className='mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.seo.blogContentTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.seo.blogContentDescription')}
             </p>
        </div>
        </div>

        <div className='mb-4'>
        <div className='mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.seo.craftedToSoarTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.seo.craftedToSoarDescription')} 
             </p>
        </div>
        </div>

        <div className='mb-4'>
        <div className='mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.seo.impactfulContentTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.seo.impactfulContentDescription')}
             </p>
        </div>
        </div>

        <div className='mb-4'>
        <div className='mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.seo.tailoredGrowthTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.seo.tailoredGrowthDescription')}
             </p>
        </div>
        </div>
        </div>
      </div>
    </section>
    </>
  )
}

export default SearchEngineOptimization